// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ControlCierreTJ_container__1OwAc {
  width: 100%;
  font-size: 16px;
  display: flex;
  justify-content: center;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_title__5wFih {
  width: 100%;
  height: 10%;
  display: flex;
  margin-top: 45px;
  margin-left: 30px;
  justify-content: flex-start;
  align-items: center;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_title__5wFih .ControlCierreTJ_icon__122ej {
  margin-left: 10px;
  width: 40px;
  height: 40px;
}
.ControlCierreTJ_container__1OwAc .ControlCierreTJ_headerLogo__fxn7v {
  margin-left: 30px;
  width: 15rem;
  max-height: 20rem;
  object-fit: contain;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_title__5wFih h2 {
  font-family: Roboto, sans-serif;
  font-weight: 300;
  width: 30%;
  margin-left: 10px;
  font-size: 2em;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 90%;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 {
  margin-top: 20px;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ControlCierreTJ_filters__Flmzn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ControlCierreTJ_filterButton__Yy2fh {
  animation: ControlCierreTJ_init3__4eaGq 0.5s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.ControlCierreTJ_filterButton__Yy2fh p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.ControlCierreTJ_date__B8gg0 {
  scale: 1;
  width: 100%;
  text-align: start;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn .ControlCierreTJ_datePickers__oHSU5 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn .ControlCierreTJ_datePickers__oHSU5 p {
  width: 100%;
  font-size: 1.2em;
  margin: 0;
  margin-left: 25px;
  margin-bottom: 10px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn .ControlCierreTJ_datePickers__oHSU5 .ControlCierreTJ_date__B8gg0 {
  scale: 0.8;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn .ControlCierreTJ_gameSelector__T-Yux {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn .ControlCierreTJ_gameSelector__T-Yux p {
  width: 100%;
  font-size: 1.2em;
  margin: 0;
  margin-left: 25px;
  margin-bottom: 10px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_filters__Flmzn .ControlCierreTJ_gameSelector__T-Yux .ControlCierreTJ_selector__HdqR2 {
  width: 100%;
  scale: 0.8;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_printOptions__mtDvV {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_printOptions__mtDvV .ControlCierreTJ_item__uriVN {
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-inline: 15px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_printOptions__mtDvV .ControlCierreTJ_item__uriVN:hover {
  transition: 0.5s;
  scale: 1.05;
  cursor: pointer;
  filter: brightness(0.4);
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_printOptions__mtDvV .ControlCierreTJ_item__uriVN .ControlCierreTJ_icons__jScsQ {
  font-size: 32px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_options__PALi5 .ControlCierreTJ_printOptions__mtDvV .ControlCierreTJ_item__uriVN p {
  font-size: 0.8em;
  text-align: center;
  margin: 0;
  margin-top: 5px;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_infoContainer__mutAp .ControlCierreTJ_tableContainer__yo\\+Cv {
  border-radius: 5px;
  margin-bottom: 30px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.198);
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_noAgencieSelected__oqWSd {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_noAgencieSelected__oqWSd h3 {
  font-size: 32px;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 10%;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_noAgencieSelected__oqWSd .ControlCierreTJ_redirectBtn__kAki2 {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 20%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_content__f94CR .ControlCierreTJ_noAgencieSelected__oqWSd .ControlCierreTJ_redirectBtn__kAki2:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.06;
  filter: brightness(1.3);
  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_noResults__CCzN1 {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 32px;
  font-weight: 300;
  height: 300px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_header__s2FVP .ControlCierreTJ_titleContainer__urU5x .ControlCierreTJ_add_btn__Obv1b {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 100px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_header__s2FVP .ControlCierreTJ_titleContainer__urU5x .ControlCierreTJ_add_btn__Obv1b:hover {
  transition: 0.3s;
  scale: 1.03;
  filter: brightness(1.2);
  cursor: pointer;
  border-radius: 5px;
}

.ControlCierreTJ_insertPaginate__Z7rye {
  width: 30px;
  height: 30px;
}

.ControlCierreTJ_insertPaginateButton__8zHKt {
  width: 30px;
  height: 30px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_header__s2FVP .ControlCierreTJ_titleContainer__urU5x {
  animation: ControlCierreTJ_init2__LUQjM 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_header__s2FVP .ControlCierreTJ_titleContainer__urU5x h4 {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

/*---Información---*/
.ControlCierreTJ_container__1OwAc .ControlCierreTJ_infoContainer__mutAp {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
  margin-bottom: 20px;
}
.ControlCierreTJ_container__1OwAc .ControlCierreTJ_infoContainer__mutAp .ControlCierreTJ_tableContainer__yo\\+Cv {
  margin-top: 20px;
  max-height: 70vh;
  overflow-y: scroll;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_dataContainer__ZFskD .ControlCierreTJ_tableContainer__yo\\+Cv .ControlCierreTJ_iconbtn__dSJ\\+a {
  transition: 0.3s;
  font-size: 30px;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_dataContainer__ZFskD .ControlCierreTJ_tableContainer__yo\\+Cv .ControlCierreTJ_iconbtn__dSJ\\+a:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_selectAgency__M0xSM {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ControlCierreTJ_iconOptions__lC8f9 {
  transition: 0.3s;
}

.ControlCierreTJ_iconOptions__lC8f9:hover {
  scale: 1.03;
  filter: brightness(0.6);
  transition: 0.3s;
  cursor: pointer;
}

.ControlCierreTJ_container__1OwAc .ControlCierreTJ_filters__Flmzn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@keyframes ControlCierreTJ_init__9mYJ1 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes ControlCierreTJ_init2__LUQjM {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes ControlCierreTJ_init3__4eaGq {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@media screen and (max-width: 500px) {
  .ControlCierreTJ_container__1OwAc .ControlCierreTJ_header__s2FVP .ControlCierreTJ_titleContainer__urU5x .ControlCierreTJ_add_btn__Obv1b {
    width: 80px;
    height: 40px;
  }
  .ControlCierreTJ_container__1OwAc .ControlCierreTJ_header__s2FVP .ControlCierreTJ_titleContainer__urU5x h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ControlCierreTJ/ControlCierreTJ.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iDAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iDAA0B;EAC1B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  width: 100%;\n  font-size: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.container .title {\n  width: 100%;\n  height: 10%;\n  display: flex;\n  margin-top: 45px;\n  margin-left: 30px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .title .icon {\n  margin-left: 10px;\n  width: 40px;\n  height: 40px;\n}\n.container .headerLogo {\n  margin-left: 30px;\n  width: 15rem;\n  max-height: 20rem;\n  object-fit: contain;\n}\n\n.container .title h2 {\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  width: 30%;\n  margin-left: 10px;\n  font-size: 2em;\n}\n\n.container .content {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 90%;\n}\n\n.container .content .options {\n  margin-top: 20px;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.filterButton {\n  animation: init3 0.5s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .content .options .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.date {\n  scale: 1;\n  width: 100%;\n  text-align: start;\n}\n\n.container .content .options .filters .datePickers {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .content .options .filters .datePickers p {\n  width: 100%;\n  font-size: 1.2em;\n  margin: 0;\n  margin-left: 25px;\n  margin-bottom: 10px;\n}\n\n.container .content .options .filters .datePickers .date {\n  scale: 0.8;\n}\n\n.container .content .options .filters .gameSelector {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .content .options .filters .gameSelector p {\n  width: 100%;\n  font-size: 1.2em;\n  margin: 0;\n  margin-left: 25px;\n  margin-bottom: 10px;\n}\n\n.container .content .options .filters .gameSelector .selector {\n  width: 100%;\n  scale: 0.8;\n}\n\n.container .content .options .printOptions {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.container .content .options .printOptions .item {\n  transition: 0.3s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-inline: 15px;\n}\n\n.container .content .options .printOptions .item:hover {\n  transition: 0.5s;\n  scale: 1.05;\n  cursor: pointer;\n  filter: brightness(0.4);\n}\n\n.container .content .options .printOptions .item .icons {\n  font-size: 32px;\n}\n\n.container .content .options .printOptions .item p {\n  font-size: 0.8em;\n  text-align: center;\n  margin: 0;\n  margin-top: 5px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .infoContainer .tableContainer {\n  border-radius: 5px;\n  margin-bottom: 30px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.198);\n}\n\n.container .content .noAgencieSelected {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .content .noAgencieSelected h3 {\n  font-size: 32px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 10%;\n}\n\n.container .content .noAgencieSelected .redirectBtn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  width: 20%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);\n}\n\n.container .content .noAgencieSelected .redirectBtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.06;\n  filter: brightness(1.3);\n  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 32px;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 45px;\n  width: 100px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn:hover {\n  transition: 0.3s;\n  scale: 1.03;\n  filter: brightness(1.2);\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.insertPaginate {\n  width: 30px;\n  height: 30px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n.container .header .titleContainer {\n  animation: init2 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n/*---Información---*/\n.container .infoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 300px;\n  margin-bottom: 20px;\n}\n.container .infoContainer .tableContainer {\n  margin-top: 20px;\n  max-height: 70vh;\n  overflow-y: scroll;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 30px;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .selectAgency {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.iconOptions {\n  transition: 0.3s;\n}\n\n.iconOptions:hover {\n  scale: 1.03;\n  filter: brightness(0.6);\n  transition: 0.3s;\n  cursor: pointer;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer .add_btn {\n    width: 80px;\n    height: 40px;\n  }\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ControlCierreTJ_container__1OwAc`,
	"title": `ControlCierreTJ_title__5wFih`,
	"icon": `ControlCierreTJ_icon__122ej`,
	"headerLogo": `ControlCierreTJ_headerLogo__fxn7v`,
	"content": `ControlCierreTJ_content__f94CR`,
	"options": `ControlCierreTJ_options__PALi5`,
	"filters": `ControlCierreTJ_filters__Flmzn`,
	"filterButton": `ControlCierreTJ_filterButton__Yy2fh`,
	"init3": `ControlCierreTJ_init3__4eaGq`,
	"date": `ControlCierreTJ_date__B8gg0`,
	"datePickers": `ControlCierreTJ_datePickers__oHSU5`,
	"gameSelector": `ControlCierreTJ_gameSelector__T-Yux`,
	"selector": `ControlCierreTJ_selector__HdqR2`,
	"printOptions": `ControlCierreTJ_printOptions__mtDvV`,
	"item": `ControlCierreTJ_item__uriVN`,
	"icons": `ControlCierreTJ_icons__jScsQ`,
	"infoContainer": `ControlCierreTJ_infoContainer__mutAp`,
	"tableContainer": `ControlCierreTJ_tableContainer__yo+Cv`,
	"noAgencieSelected": `ControlCierreTJ_noAgencieSelected__oqWSd`,
	"redirectBtn": `ControlCierreTJ_redirectBtn__kAki2`,
	"noResults": `ControlCierreTJ_noResults__CCzN1`,
	"header": `ControlCierreTJ_header__s2FVP`,
	"titleContainer": `ControlCierreTJ_titleContainer__urU5x`,
	"add_btn": `ControlCierreTJ_add_btn__Obv1b`,
	"insertPaginate": `ControlCierreTJ_insertPaginate__Z7rye`,
	"insertPaginateButton": `ControlCierreTJ_insertPaginateButton__8zHKt`,
	"init2": `ControlCierreTJ_init2__LUQjM`,
	"dataContainer": `ControlCierreTJ_dataContainer__ZFskD`,
	"iconbtn": `ControlCierreTJ_iconbtn__dSJ+a`,
	"selectAgency": `ControlCierreTJ_selectAgency__M0xSM`,
	"iconOptions": `ControlCierreTJ_iconOptions__lC8f9`,
	"init": `ControlCierreTJ_init__9mYJ1`
};
export default ___CSS_LOADER_EXPORT___;
